import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-scheduler-view-options',
  templateUrl: './scheduler-view-options.component.html',
  styleUrls: ['./scheduler-view-options.component.scss']
})
export class SchedulerViewOptionsComponent implements OnInit {
  @Output() viewTypeChange = new EventEmitter<string>();

  selectedType: string = 'day';

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.isItemSelected(this.selectedType);
  }

  changeView(type: string) {
    switch (type) {
      case 'standardView':
        this.router.navigateByUrl('scheduler');
        this.viewTypeChange.emit('day');
        this.selectedType = 'day';
        break;
      case 'dayDetailView':
        // this.router.navigateByUrl('scheduler/day-detail-view');
        this.viewTypeChange.emit('dayDetailView');
        this.selectedType = 'dayDetailView';
        break;
      case 'weekView':
        this.router.navigateByUrl('scheduler');
        this.viewTypeChange.emit('week');
        this.selectedType = 'week';
        break;
      case 'monthView':
        this.router.navigateByUrl('scheduler');
        this.viewTypeChange.emit('month');
        this.selectedType = 'month';
        break;
    }
  }

  isItemSelected(type: string): boolean {
    return type === this.selectedType;
  }
}
